import React, { Component } from 'react';
import { connect } from 'react-redux';
import i18n from "../../../../i18next";

import {
    loadCurbsideSettings,
    loadAllTenderTypes,
    updateCurbsideSettings,
    resetCurbsideSettings,
    resetTenderTypes,
    getPaymentSettings
} from '../../../../actions/index';
import ServiceSettings from './ServiceSettings';
import { getCurrencySymbol } from "../../../../utils/CommonUtils";
import { MENUU_ADMIN, MENUU_MASTER_ADMIN } from '../../../../utils/Constants';

class CurbsideScreen extends Component {
    constructor(props) {
        super(props);

        this.state = {
            settingsData: []
        }

        this.updateCurbsideSettings = this.updateCurbsideSettings.bind(this);
    }

    componentDidMount() {
        const { role } = this.props.currentlyLoggedInUser;
        this.props.loadAllTenderTypes();
        const restaurantId = this.props.match.params.id;
        this.props.loadCurbsideSettings(restaurantId);
        // Response and callback are used to prepopulate payment types
        if (role === MENUU_MASTER_ADMIN) {
            this.props.getPaymentSettings(restaurantId);
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.curbsideSettings !== prevProps.curbsideSettings) {
            this.setState({
                settingsData: this.props.curbsideSettings
            });
        }
    }

    componentWillUnmount() {
        this.props.resetCurbsideSettings();
        this.props.resetTenderTypes();
    }

    updateCurbsideSettings(settings, callback) {
        const restaurantId = this.props.match.params.id;
        let filteredPrepTimes = [];

        if (this.props.serviceSettingsGeneral.timeSlotBased) {
            settings.timeSlots = [...settings.preparationTimes];
            settings.preparationTimes = [];
        } else {
            settings.preparationTimes.map(prepTime => {
                let prepTimeCopy = {...prepTime};
                delete prepTimeCopy.maxOrders;
                delete prepTimeCopy.maxValue;
                delete prepTimeCopy.duration;

                filteredPrepTimes.push(prepTimeCopy);
            });

            settings.preparationTimes = filteredPrepTimes;
        }

        this.props.updateCurbsideSettings(restaurantId, settings, callback);
    }

    render() {
        const curbsideTranslation = i18n.t('common:deliveryCollectionDineInCurbside.operationHoursCurbside');
        const currency = getCurrencySymbol(this.props.restaurant.currency);

        return (
            <ServiceSettings
                settings={this.props.curbsideSettings}
                prepopulatedSettings={this.state.settingsData}
                updateSettings={this.updateCurbsideSettings}
                tenderTypes={this.props.tenderTypes}
                translationPhrase={curbsideTranslation}
                currency={currency}
                timeSlotBased={this.props.serviceSettingsGeneral.timeSlotBased}
            />
        );
    }
}

const mapStateToProps = (state) => {
    return {
        serviceSettingsGeneral: state.serviceSettingsGeneral,
        curbsideSettings: state.curbsideSettings,
        tenderTypes: state.tenderTypes,
        restaurant: state.restaurant,
        currentlyLoggedInUser: state.user
    }
}

export default connect(mapStateToProps, {
    loadAllTenderTypes,
    loadCurbsideSettings,
    updateCurbsideSettings,
    resetCurbsideSettings,
    resetTenderTypes,
    getPaymentSettings
})(CurbsideScreen);


// WEBPACK FOOTER //
// ./src/components/restaurants/settings/service/CurbsideScreen.js